import { VideoCameraIcon, VideoCameraSlashIcon } from "@heroicons/react/24/outline";
import Button from "@ergeon/core-components/exports/Button.ts";

import { useAppContext } from '@/app/AppContext';
import { EVENTS, gtag } from '@/lib/gtag';

export default function ButtonCamera() {
  const appState = useAppContext();

  const onButtonClick = () => {
    appState.camera.toggleDevice();

    gtag(EVENTS.TOGGLE_DEVICE, { device: 'camera' });
  };

  const isEnabled = appState.camera.isEnabled;
  const Icon = isEnabled ? VideoCameraIcon : VideoCameraSlashIcon;

  return (
    <Button
      flavor={isEnabled ? "regular" : "danger"}
      isSquare
      shape="circle"
      onClick={onButtonClick}
      size="large"
      title="Camera on/off">
      <Icon className="size-6" />
    </Button>
  );
}
